import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { VoucherDetailRequest, VoucherSearchGridRequest } from "@/main/models/request";
import { VoucherDetailResponse, VoucherSearchGridResponse } from "@/main/models/response";

export abstract class IVoucherApi {
	abstract getVoucherTypes(): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getVoucherRefundStatus(): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getRefunds(request: VoucherSearchGridRequest): Promise<AxiosResponse<Result<VoucherSearchGridResponse>>>;

	abstract getClaimVouchers(
		request: VoucherDetailRequest,
		abortSignal?: AbortSignal,
	): Promise<AxiosResponse<Result<VoucherDetailResponse>>>;
}
